/**
 * Documents d'un rendez-vous, tels que le secrétariat les voit.
 *
 * Nicolas, 11/09 :
 *   — le scan IA ecrivait la meme photo dans `iaPrescription` ET `prescription`,
 *     donc deux pastilles « Ordonnance » ;
 *   — les ordo suivantes remplissent Ordo 2, 3, 4… ; l'ecran montre les 3
 *     premieres par defaut.
 */

import { TYPE_FICHIER_PAR_CLE } from "./documentNaming";

const ORDO_SLOTS = [
  { key: "prescription", type: "Ordonnance" },
  { key: "prescriptiontwo", type: "Ordonnance 2" },
  { key: "prescriptionthree", type: "Ordonnance 3" },
  // Nicolas, 14/09 : « ajouter "4eme ordo" ». La tablette a desormais un
  // emplacement dedie, nomme comme les trois autres ; `prescriptionsExtra`
  // ne recoit plus que la 5e et les suivantes.
  { key: "prescriptionfour", type: "Ordonnance 4" },
];

const AUTRES = [
  { key: "mutual", type: "Mutuelle" },
  { key: "IDCard", type: "Pièce d'identité" },
  { key: "vitalCard", type: "Carte Vitale" },
  // Nicolas, 14/09 : « consentement », photographie a la tablette.
  { key: "consent", type: "Consentement" },
  { key: "document", type: "Document" },
];

function entree(appointment, key, type) {
  if (!appointment?.[key]) return null;
  return {
    id: `doc-${key}`,
    key,
    type,
    typeFichier: TYPE_FICHIER_PAR_CLE[key] || "document",
    storagePath: appointment[key],
    sglStatus: "NOT_SENT",
    ordoIndex: type.startsWith("Ordonnance") ? Number(type.replace(/\D/g, "") || 1) : null,
  };
}

export function documentsDepuisRendezVous(appointment = {}) {
  const docs = [];
  const aOrdo1 = !!appointment.prescription;
  if (appointment.iaPrescription && !aOrdo1) {
    docs.push(entree(appointment, "iaPrescription", "Ordonnance"));
  }
  for (const slot of ORDO_SLOTS) {
    const d = entree(appointment, slot.key, slot.type);
    if (d) docs.push(d);
  }
  const extra = Array.isArray(appointment.prescriptionsExtra)
    ? appointment.prescriptionsExtra.filter(Boolean)
    : [];
  // Les ordonnances en plus se numerotent a la suite de la derniere
  // ordonnance a emplacement. Un dossier d'avant le 14/09 n'a pas d'Ordo 4
  // dediee : sa premiere « extra » reste l'Ordonnance 4, comme avant.
  const derniereOrdo = docs.reduce((max, d) => Math.max(max, d?.ordoIndex || 0), 0);
  extra.forEach((path, i) => {
    const n = derniereOrdo + 1 + i;
    docs.push({
      id: `doc-prescriptionsExtra-${i}`,
      key: `prescriptionsExtra.${i}`,
      type: `Ordonnance ${n}`,
      typeFichier: `ordo${n}`,
      storagePath: path,
      sglStatus: "NOT_SENT",
      ordoIndex: n,
      extra: true,
    });
  });
  for (const autre of AUTRES) {
    const d = entree(appointment, autre.key, autre.type);
    if (d) docs.push(d);
  }
  return docs.filter(Boolean);
}

/**
 * Les ordonnances photographiees a leur emplacement, plus tous les autres
 * documents ; les ordonnances « en plus » au-dela de `ordoMax`.
 *
 * 11/09 : l'ecran montre les 3 premieres par defaut. 14/09 : Nicolas demande
 * une « 4eme ordo » comme type a part entiere — une photo prise a la main a
 * cet emplacement doit donc apparaitre. Seules les ordonnances rangees
 * automatiquement dans `prescriptionsExtra` restent sous le seuil. Pour un
 * dossier d'avant le 14/09 (trois emplacements), le resultat est inchange.
 */
export function documentsAffiches(docs = [], ordoMax = 3) {
  let ordoVus = 0;
  return docs.filter((d) => {
    if (!String(d.type || "").startsWith("Ordonnance")) return true;
    ordoVus += 1;
    if (!d.extra) return true;
    return ordoVus <= ordoMax;
  });
}

export function heurePriseEnCharge(appointment) {
  const ts =
    appointment?.priseEnChargeDebut ||
    appointment?.started_at ||
    appointment?.created_at;
  return ts || null;
}
